/* This should be a value a language .json file definitely exists for. */
export const FALLBACK_LANGUAGE_LOCALE = 'en-US';

/* This constant could in future be automatically generated based on the contents of the /assets/i18n folder
 * Please avoid duplicates in this array and sort the locale strings alphabetically. We do not use Array.from(new Set()) anymore because
 * TypeScript cannot derive the union type from it correctly. Instead, we are using a const Array here again. */
export const SUPPORTED_LANGUAGE_LOCALES = [
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'de-IT',
  'de-LU',
  'el-GR',
  'en-GB',
  'en-US',
  'es-ES',
  'fi-FI',
  'fr-BE',
  'fr-CH',
  'fr-FR',
  'fr-LU',
  'it-CH',
  'it-IT',
  'nb-NO',
  'nl-BE',
  'en-US',
  'nl-NL',
  'pt-PT',
  'sv-SE'
] as const;

export type SupportedLanguageLocale = typeof SUPPORTED_LANGUAGE_LOCALES[number];

/* Name of the cookie in which the preferred language is stored */
export const PREFERRED_LANGUAGE_COOKIE_NAME = 'user_preferred_language';
